import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useCart } from "../context/CartContext";

export const PromoLinkCatcher = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { savePendingCode, items } = useCart();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = (params.get("promo") || "").trim().toUpperCase();
    if (!code) return;
    savePendingCode(code);
    if (items.length === 0) toast.success(`Promo code ${code} saved`, { description: "It will be applied when you add something to your bag." });
    params.delete("promo");
    const qs = params.toString();
    navigate({ pathname: location.pathname, search: qs ? `?${qs}` : "", hash: location.hash }, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return null;
};
